import { render, staticRenderFns } from "./HomeMessage.vue?vue&type=template&id=63c6e112&scoped=true"
import script from "./HomeMessage.vue?vue&type=script&lang=js"
export * from "./HomeMessage.vue?vue&type=script&lang=js"
import style0 from "./HomeMessage.vue?vue&type=style&index=0&id=63c6e112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c6e112",
  null
  
)

export default component.exports